<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail input-scan-page" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Picking For Delivery Detail">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
					<app-label v-if="parentValueInfo != undefined && parentValueInfo != null && parentValueInfo != ''" label-cols-lg="12" size="sm" :label="parentLabelInfo" :model="parentValueInfo" />
				<app-input-textbox id="fieldset-plan-qty" label-cols-lg="12" label="Plan Qty" label-for="input-plan-qty" size="sm" :model.sync="model.planQty"  />
					</b-col>
					<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-actual-qty" label-cols-lg="12" label="Actual Qty" label-for="input-actual-qty" size="sm" :model.sync="model.actualQty"  />

				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import focusInput from '@/mixins/focusInputMixin';
import PickingForDeliveryDetail from '@/models/PickingForDelivery/PickingForDeliveryDetail';
import PickingForDeliveryDetailFilter from '@/filters/PickingForDelivery/PickingForDeliveryDetailFilter';

import PickingForDelivery from '@/models/PickingForDelivery/PickingForDelivery';
import PickingForDeliveryFilter from '@/filters/PickingForDelivery/PickingForDeliveryFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import DeliveryInstructionDetail from '@/models/DeliveryInstruction/DeliveryInstructionDetail';
import DeliveryInstructionDetailFilter from '@/filters/DeliveryInstruction/DeliveryInstructionDetailFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import PopupRouterView from '@/components/PopupRouterView';
import AppInputScan from '@/components/AppInputScan';
export default {
	props: ['model','modelId', 'openPopup','addButtonMethod', 'resetMethod', 'parentLabelInfo', 'parentValueInfo'],
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		PopupRouterView,
		AppInputScan,
	},
	mixins : [validationMixin, focusInput],
	validations: {
		model: {
		deliveryInstructionDetailId: {required},
		}
	},
	data() {
		return {
			errorMessage : {
				deliveryInstructionDetailId: { required : "Delivery Instruction Detail is Required."},
			},
			deliveryInstructionDetails : [],
			isBusy: false,
		}
	},
	methods : {
		getPickingForDeliveryDetail : async function(id) {
			this.isBusy = true;
			PickingForDeliveryDetail.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getDeliveryInstructionDetails : async function(input) {
			let filter = new DeliveryInstructionDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			DeliveryInstructionDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionDetails = result.data
				}
			})
			.catch(error => {});
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				let model = this.model;
				let promises = Array();
				let _this = this;
					

					
				Promise.all(promises).then((results) => {
					_this.$emit("addButtonMethod", modalEvent, _this.model); 
				});

				this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},
		scanDeliveryInstructionDetail() {
			this.focusInput(this, "fieldset-deliveryinstructiondetail");
		},

	},	beforeMount() {
		//this.getDeliveryInstructionDetails();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getPickingForDeliveryDetail(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getDeliveryInstructionDetails();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getPickingForDeliveryDetail(this.modelId);
				}
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
